import React from "react";
import { Globe } from "lucide-react";
import { doctorProfile } from "../data/mockData";
import "../styles/ProfessionalOverview.css";

const ProfessionalOverview = () => {
  return (
    <section id="about" className="professional-overview-section">
      <div className="overview-container">
        <div className="overview-image-side">
          <div className="overview-image-wrapper">
            <img
              src="/images/doctor-profile.jpg"
              alt="Medical Consultation"
              className="overview-image"
            />
            <div className="image-accent-overlay"></div>
          </div>
        </div>

        <div className="overview-content-side">
          <div className="section-label">About Dr. Kumar</div>
          <h2 className="overview-title">
            Dedicated to Cardiovascular Excellence
          </h2>

          <p className="overview-bio">{doctorProfile.bio}</p>

          <div className="philosophy-card">
            <div className="philosophy-icon">💙</div>
            <div className="philosophy-content">
              <h3 className="philosophy-title">Patient Care Philosophy</h3>
              <p className="philosophy-text">{doctorProfile.philosophy}</p>
            </div>
          </div>

          <div className="overview-meta">
            <div className="meta-item">
              <Globe size={20} />
              <div>
                <div className="meta-label">Languages</div>
                <div className="meta-value">
                  {doctorProfile.languages.join(", ")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalOverview;
